module.exports = "/fast-coin/img/coin/anim/out_1/out_1_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_008.png
// module id = 2304
// module chunks = 5